/**
 * Objeto que representa uma opção de resposta da questão
 */
class QuestionarioOpcaoResposta {

    /**
     * Cria uma nova instância de uma opção de resposta
     * Caso os parâmetros não sejam informados, cria com as propriedades vazias
     * 
     * @param {Number|null} id Id da opção de resposta na API
     * @param {String|null} descricao Descrição da opção
     * @param {String|null} imagem URL da imagem salva no servidor
     * @param {Number|null} valor Valor numérico da opção
     * @param {Number|null} ordem Ordem da opção de resposta na questão
     * @param {String|null} novaImagem Conteúdo da imagem que irá substituir a anterior
     * @param {String|null} copiaImagem URL da imagem salva que deve ser copiada
     */
    constructor (id, descricao, imagem, valor, ordem, novaImagem, copiaImagem) {
        /** @param {Number|null} id Id da opção de resposta na API */
        this.id = id ?? null;
        /** @param {String|null} descricao Descrição da opção */
        this.descricao = descricao ?? '';
        /** @param {String|null} imagem URL da imagem salva no servidor */
        this.imagem = imagem ?? null;
        /** @param {Number|null} valor Valor numérico da opção */
        this.valor = valor ?? null;
        /** @param {Number|null} ordem Ordem da opção de resposta na questão */
        this.ordem = ordem ?? 1;
        /** @param {String|null} novaImagem Conteúdo da imagem que irá substituir a anterior */
        this.novaImagem = novaImagem ?? null;
        /** @param {String|null} copiaImagem URL da imagem salva que deve ser copiada */
        this.copiaImagem = copiaImagem ?? null;
    }

    /**
     * Realiza uma cópia do objeto
     * @param {QuestionarioOpcaoResposta} resposta Objeto a ser clonado
     * @returns {QuestionarioOpcaoResposta} Novo objeto com os mesmos dados do original
     */
    static clone(resposta) {
        return new QuestionarioOpcaoResposta(resposta.id, resposta.descricao, resposta.imagem, resposta.valor, resposta.ordem, resposta.novaImagem, resposta.copiaImagem);
    }

    /**
     * Compara duas opções de resposta, retornando verdadeiro se elas forem iguais
     * @param {QuestionarioOpcaoResposta} obj1 Primeiro objeto a ser comparado
     * @param {QuestionarioOpcaoResposta} obj2 Segundo objeto a ser comparado
     * @returns {Boolean} Retorna verdadeiro se os dois objetos forem iguais
     */
    static compare(obj1, obj2) {
        //Se os dois possuírem o mesmo endereço de memória
        if (obj1 === obj2)
            return true;
        //Se um dos dois for nulo
        if (!obj1 || !obj2)
            return false;
        //Compara as propriedades
        return obj1.id === obj2.id
            && obj1.descricao === obj2.descricao
            && obj1.imagem === obj2.imagem
            && obj1.valor === obj2.valor
            && obj1.ordem === obj2.ordem
            && obj1.novaImagem === obj2.novaImagem
            && obj1.copiaImagem === obj2.copiaImagem;
    }
}

export default QuestionarioOpcaoResposta;